import React, { useState, useEffect, useContext } from "react";
import { ethers } from "ethers";
import { Box, Center, HStack, Text } from "@chakra-ui/react";
import { AppContext } from "../../AppContext";
import BlindfoldWallet from "../../contracts/BlindfoldWalletV2.json";
import FetchPaymasterBalance from "./FetchPaymasterBalance";

const WalletDetails = ({paymasterAddress}) => {
  const [walletDetails, setWalletDetails] = useState(null);
  const { fastestWebSocket, contractAddress } = useContext(AppContext);
  const [paymasterBalance, setPaymasterBalance] = useState(null);

  const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);
  const [signalInterval, setSignalInterval] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSignalInterval = async () => {
    setLoading(true);
    setError(null);
    try {
      // Connect to the AVAX provider
      const provider = new ethers.providers.WebSocketProvider(fastestWebSocket);
      
      // Create contract instance
      const contract = new ethers.Contract(contractAddress, BlindfoldWallet.abi, provider);

      // Call the getSignalInterval function
      const interval = await contract.getSignalInterval();

      // Update state with the fetched interval
      setSignalInterval(interval);
    } catch (err) {
      setError(`Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const fetchWalletDetails = async (contractAddress) => {
    if (!contractAddress) return; // Prevent calling with undefined address
    try {
      const walletContract = new ethers.Contract(
        contractAddress,
        BlindfoldWallet.abi,
        provider
      );
      const [tradesEnabled, version, getLossLimit, getSellLimit, paymasterSharePercentage, leverageMultiplier, signalInterval] = await Promise.all([
        walletContract.tradesEnabled(),
        walletContract.version(),
        walletContract.getLossLimit(),
        walletContract.getSellLimit(),
        walletContract.paymasterSharePercentage(),
        walletContract.leverageMultiplier(),
        walletContract.signalInterval()
      ]);
      setWalletDetails({ tradesEnabled, version, getLossLimit, getSellLimit, paymasterSharePercentage, leverageMultiplier, signalInterval });
    } catch (error) {
      console.error("Error fetching wallet version and trades enabled:", error);
    }
  };

  useEffect(() => {
    if (contractAddress) {
      fetchWalletDetails(contractAddress); // Now correctly passing contractAddress
      fetchSignalInterval();
    }
  }, [contractAddress]);

  if (!walletDetails) {
    return <Center>Loading wallet details...</Center>;
  }

  return (
    <Box fontFamily="Sentinel-light" maxWidth="300px">
      <Box minWidth="290px"   w="100%"  mb={2}>
        {walletDetails && (
          <>
          
            {/** VERSION */}
            <HStack w="100%">
              <Text>
                <strong>Version:</strong>{" "}
              </Text>
              <Text>{walletDetails.version ? walletDetails.version.toString() : "N/A"}</Text>
            </HStack>
            {/** ENABLE TRADES */}
            <HStack w="100%">
              <Text>
                <strong>Trades Enabled:</strong>{" "}
              </Text>
              <Text color={walletDetails.tradesEnabled ? "green.500" : "red.500"}>
                {walletDetails.tradesEnabled ? "Yes" : "No"}
              </Text>
            </HStack>

            {/** LOSS LIMIT */}
          <HStack w="100%">
              <Text>
                <strong>Loss Limit:</strong>{" "}
              </Text>
              <Text>{walletDetails.getLossLimit ? walletDetails.getLossLimit.toString() : "N/A"}</Text>
            </HStack>
            {/** SELL LIMIT */}
            <HStack w="100%">
              <Text>
                <strong>Sell Limit:</strong>{" "}
              </Text>
              <Text>{walletDetails.getSellLimit ? walletDetails.getSellLimit.toString() : "N/A"}</Text>
            </HStack>

            {/** LEVERAGE MULTIPLIER */}
            <HStack w="100%">
              <Text>
                <strong>Leverage Multiplier:</strong>{" "}
              </Text>
              <Text>{walletDetails.leverageMultiplier ? walletDetails.leverageMultiplier.toString() : "N/A"}</Text>
            </HStack>

            <HStack w="100%">
              <Text>
                <strong>Interval:</strong>{" "}
              </Text>
              <Text>{signalInterval ? signalInterval : "N/A"}</Text>
            </HStack>

            
            {/** PM SHARE % */}
            <HStack w="100%">
              <Text>
                <strong>Paymaster Share:</strong>{" "}
              </Text>
              <Text>{walletDetails.paymasterSharePercentage ? walletDetails.paymasterSharePercentage.toString() : "N/A"}%</Text>
            </HStack>
            <FetchPaymasterBalance 
        fastestWebSocket={fastestWebSocket} 
        paymasterAddress={paymasterAddress}
        onBalanceFetched={setPaymasterBalance} 
      />
            
          </>
        )}
      </Box>
    </Box>
  );
};

export default WalletDetails;
